import { render, staticRenderFns } from "./m-edit-wall-time.vue?vue&type=template&id=6134368a&scoped=true&"
import script from "./m-edit-wall-time.vue?vue&type=script&lang=js&"
export * from "./m-edit-wall-time.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6134368a",
  null
  
)

export default component.exports